//import SelectBox from "./SelectBox";
import React from "react";
//import Multiselect from "multiselect-react-dropdown";
import { useForm, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import * as Yup from "yup";
import { saveShoppingPartners, 
        resetApiStatus, 
        allParentList as allParentListFnc, 
        getPartnerById } from "../../slices/ShoppingPartnersSlices";
import { useDispatch, useSelector } from "react-redux";
import SelectBox from "../../components/admin/SelectBox";
import  defaultConfig  from "../../config/Config"
import { Loading } from "../Loading";
import { MessageModel } from "../MessageModel";
import { CityByState, cityPincode, getAllState, getCatList } from "../../slices/InitialDataSlice";
import { GoogleMap } from "../../features/shoppingPartners/google-map";
import { getLocationByLatLang } from "../../Utils/utils/CommanFnc";
import { imageTypeList } from "../../features/shoppingPartners/const";
import { imageValidation } from "../../Utils/utils";
import ModelBox from "../../common/ModelBox";
import { ReplaceUser } from "../../components/admin/user/ReplaceUser";

export function UserForm() {
  const locationData = useLocation()
  const [user, setUser] = useState({})
  const success = useSelector((state) => state.shoppingPartners.success);
  const vErrors = useSelector((state) => state.shoppingPartners.errors);
  const loading = useSelector((state) => state.shoppingPartners.loading);
  const googleMapApiLoaded = useSelector((state) => state.initialData.googleMapApiLoaded);
  const {
      allParentList,
      editData
    } = useSelector( (state)  => state.shoppingPartners )
 
  const initialData = useSelector( (state) => state.initialData )
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams()
  const [cities, setCities] = useState([])
  const [states, setStates] = useState([])
  const [files, setFiles] = useState({})
  const [isMapOpen, setIsMapOpen] = useState(false)
  const [imageSchema, setImageSchema] = useState({})
  const [parentList, setParentList] = useState([])
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState();
  const formSchema = Yup.object().shape({
    name: Yup.string().required("Please enter full name"),
    shopName: Yup.string().required("Please enter shop name"),
   
    address: Yup.string()
      .required("Please enter address"),
    city: Yup.string()
        .required("Please select city"),
    state: Yup.string()
        .required("Please select state"),
    category: Yup.mixed()
    .test('required', "You select category", (value) =>{
      if (params.type === "retailers") {
          return value && value.length > 0
      } else { 
        return true
      }
    }),
    phone: Yup.string()
      .required("Please enter mobile number")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Please enter valid mobile number"
      ),
    pincode: Yup.string()
      .required("Please enter pincode"),
      
    ...imageSchema
  });
  const [imagesType, setImageType] = useState(imageTypeList)
  const [latLng, setLatLng] = useState("")
  const [parentField, setParentField] = useState()  
  const [pincodes, setPincodes] = useState([])  
  const [cateList, setCateList] = useState([])
  const [vendorType, setVendorType] = useState('')
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });

  useEffect( () => {
    if(params.id){
      let type = params.type
      if(params.type === "distributors"){
        type = "distributors"
      }else if(params.type === "retailers") {
        type = "retailer"
      }
      dispatch(getPartnerById({id:params.id, type}))
    }
  }, [dispatch])

  useEffect( () => {
    let parentFieldType = {}
    if(params.type === "retailers"){
      parentFieldType = { label: "Distributor", key: "distributors" }
    }else if(params.type === "superStockists"){
      parentFieldType = {label: "CSA", key: "csa"}
    }else if(params.type === "distributors"){
      // eslint-disable-next-line no-unused-vars
      parentFieldType = {label:"Super Stockists", key:"superStockists"}
    }
    setParentField(parentFieldType)
    dispatch(getAllState())
    setValue("type", params.type)
    setImageSchema(imageValidation(
      {
        imagesType,
        Yup,
        user
      }
    ))
    dispatch(getCatList({type:"vendor"}))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch])

  useEffect( () => {
    if(initialData?.StateList !== states){
        let list = []
        initialData?.StateList?.forEach(item => {
                    if(item._id !== ""){
                      list.push({
                        value : item._id,
                        label: item.name
                      })
                    }
        })
        setStates(list)
    }

    if(initialData?.CitiesList !== cities){
      let list = []
      initialData?.CitiesList.forEach(item => {
                  if(item._id !== ""){
                    list.push({
                      value : item._id,
                      label: item.name
                    })
                  }
      })
      setCities(list)
    }

    if(allParentList !== parentList){
      let list = allParentList?.map( (item) => {
        return {
          label: `${item.name}`,
          value: item._id
        }
      })
      setParentList(list)
    }

    if(initialData?.categories !== cateList){
      let list = []
      list = initialData?.categories?.map( ({_id, name}) => { return {label: name, value: _id} } )    
      setCateList(list)
    }

    if(initialData?.pincodeList !== pincodes){
      let list = []
      initialData?.pincodeList?.forEach(item => {
                  if(item._id !== ""){
                    list.push({
                      value : item._id,
                      label: `${item.pincode} (${item.name})`
                    })
                  }
      })
      setPincodes(list)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[initialData?.CitiesList, initialData?.StateList, allParentList, initialData?.pincodeList, initialData.categories])

  useEffect( ()=>{
    if(!editData && params.id){
      navigate(`/add-shopping-partner/${params.type}`)
    }
    let {...others} = editData;
    setUser(others)
    
    for( let key in others ){
      if(key !== "city" && key !== 'pincode' && key !== 'parentUser'){
        if(others[key]){
          setValue(key, others[key])
        }
      }
    }

    if(editData.state){
      dispatch(CityByState(editData.state)).then(()=>{
        setValue('city', editData.city)    
      })  
    }

    if(editData.city){
      dispatch(cityPincode({cityId: editData.city})).then(()=>{
        setValue('pincode', editData.pincode)    
      })  
    }

    if(editData.pincode){
      dispatch(allParentListFnc({pincode: editData.pincode, type: parentField?.key})).then(()=>{
        if(editData.parentUser){
          setValue('parentUser', editData.parentUser)    
        }
      })  
    }

    if(imagesType){
      imagesType.forEach((item) => {
          item.imagePath =  `${defaultConfig.localDocFilePath}/assets/${editData.userId}/${others[item.name]}`
      })
    }
    if(others?.latitude && others?.longitude){
      setValue('lat_long', `${others.latitude},${others.longitude}`)
    }
    
    //return () => dispatch(resetApiStatus())

    // setImagePath((props)=>{
    //   return data?.image?data.image:props
    // })
  },[dispatch, navigate, params.id, setValue, editData, params.type, imagesType, parentField?.key])

  useEffect( ()=>{
    if(editData?.latitude && editData?.longitude){
      getLocationByLatLang({lat: parseFloat(editData.latitude), lng: parseFloat(editData.longitude)}).then((place)=>{
        setValue('location', place?.formatted_address)
      })
      
    }
  },[editData?.latitude, editData?.longitude, googleMapApiLoaded, setValue])

  async function onSubmit(data){
    delete data.confPass
    imagesType.forEach( (item) =>{
      delete data[item.name]
    } )
    const [latitude, longitude] = data.lat_long.split(",")
    data.latitude = latitude
    data.longitude = longitude
    data.files = files
    data.password = "123456"
    data.gender = "male"
    if(data._id){
      data.detailId = data.userDetailId
    }
    dispatch(saveShoppingPartners(data));
    //navigate("/users-list");
  };
  
  function onCancel(e){
    const queryString  = new URLSearchParams(locationData.state).toString()
    navigate(`/shopping-partners/${params.type}?${queryString}`);
    return;
  }

  const onDrop = (pictureFiles) => {
    if(pictureFiles.target.files.length > 0){
        const imgPath =  URL.createObjectURL(pictureFiles.target.files[0])
        setFiles((prev)=>{
            return {
              ...prev,
              [pictureFiles.target.name]:pictureFiles.target.files
            }
        })
        const selecetdFile = imagesType.find( (item) => item.name === pictureFiles.target.name )
        selecetdFile.imagePath = imgPath
        setImageType(imagesType)
    }
	};

  // const formatOptionLabel = ({ value, label, image }) => (
  //   <div style={{ display: "flex" }}>
  //     <div>{image?<img className="optionImg" alt={`${label}`} src={image} />:''} {label}&nbsp;</div>
  //   </div>
  // );

  const onStateChange = (callback, opt)=>{
      dispatch(CityByState(opt.value))
      callback(opt.value)
  }

  const onPincodeChange = (callback, opt)=>{
    if(params.type === "retailers" || params.type === "superStockists" || params.type === "distributors"){
      dispatch(allParentListFnc({pincode: opt, type: parentField?.key}))
    }
    callback(opt)
}

  const onCityChange = (callback, opt)=>{
    dispatch(cityPincode({cityId:opt}))
    callback(opt)
  }

  const setLocationData = (location) => {
    const value = `${location.lat},${location.lng}`
    setLatLng(value)
    setValue('lat_long',value)
    setValue('location',location.address)
    setValue('address',location.address)
  }

  const openMap = () => {
    setLatLng(getValues('lat_long'))
    if(isMapOpen){
      setIsMapOpen(false)
    }else{
      setIsMapOpen(true)
    }
  }

  function onStatusChange(callBack, value) {
    const {
      _id: userId,
      name: fullName
    } = getValues();
    if ( value === 'inactive' && userId) {
        setShowStatusPopup(true);
        const onSubmit = (selectedTeamMember) => {
          setShowStatusPopup(false);
          setValue('replaceById', selectedTeamMember)
        }
        const params = { fullName, onSubmit, type: vendorType, userId: user._id  }
        setPopUpContent( <ReplaceUser params = {  {...params} }/>)   
    } else {
      setValue('replaceById', null)
    }
    callBack(value)
}

useEffect( () => {
  const type = defaultConfig.dashboardUserType.find( (item) => item.value === params?.type )
  setVendorType(type?.label)
}, [params])


  return (
    <div className="row">
      <div className="col-md-6 col-lg-12">
        <div className="card payment-card">
          <div className="card-header">
            <h4 className="card-title">
                { editData?.shopName?`EDIT ${editData.vendorCode} ${editData?.shopName} `:`ADD `} {defaultConfig.partners[params.type]['label']}
            </h4>
          </div>
          <hr/>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                  <input 
                    {...register("replaceById")} 
                    type="hidden" 
                    disabled={ !getValues('replaceById') }
                    readOnly
                    autoComplete="false" className={`input-txt form-control`}
                  />
                  <input
                    {...register("_id")}
                    type="hidden"
                    className={`input-txt form-control`}
                  />
                  <input 
                    {...register("type")}
                    type={"hidden"}
                  />

                  <div className="row">
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          
                          className={`input-label ${errors.name && "error"}`}
                        >
                          Name
                        </label>
                        <input
                          {...register("name")}
                          type="text"
                          defaultValue=""
                          id="card-number"
                          placeholder="Name"
                          className={`input-txt form-control ${
                            errors.name && "error"
                          }`}
                        />
                        {errors.name && (
                          <FormError message={errors.name.message} />
                        )}
                      </div>
                    </div>

                    {/* <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          
                          className={`input-label ${errors.email && "error"}`}
                        >
                          Email
                        </label>
                        <input
                          {...register("email")}
                          type="text"
                          className={`input-txt form-control ${
                            errors.email && "error"
                          }`}
                          placeholder="Email"
                        />
                        {errors.email && (
                          <FormError message={errors.email.message} />
                        )}
                      </div>
                    </div> */}

                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label  className={`input-lable ${errors.phone && "error"}`}>
                          Mobile
                        </label>
                        <input
                          type="text"
                          className={`input-label form-control ${
                            errors.phone && "error"
                          }`}
                          placeholder="Mobile Number"
                          {...register("phone")}
                        />
                        {errors.phone && (
                          <FormError message={errors.phone.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          
                          className={`input-label ${errors.shopName && "error"}`}
                        >
                          Shop Name
                        </label>
                        <input
                          {...register("shopName")}
                          type="text"
                          defaultValue=""
                          id="card-number"
                          placeholder="Shop Name "
                          className={`input-txt form-control ${
                            errors.shopName && "error"
                          }`}
                        />
                        {errors.shopName && (
                          <FormError message={errors.shopName.message} />
                        )}
                      </div>
                    </div>

                    {/* <div className="col-4">
                      <div className="form-group mb-3">
                        <label className={`d-block ${errors.gender && "error"}`}>
                          Gender
                        </label>
                        <Controller
                          control={control}
                          name="gender"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.gender}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={defaultConfig.gender.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.gender && (
                          <FormError message={errors.gender.message} />
                        )}
                      </div>
                    </div> */}
                  </div>
                   {/* {
                    !user?<React.Fragment > <div style={{display:"none"}} className="col-4">
                          <div className="form-group mb-3">
                            <label htmlFor="password" className={`input-lable ${errors.password && "error"}`}>
                              Password
                            </label>
                            <input
                              type="password"
                              {...register("password")}
                              className={`input-label form-control ${
                                errors.password && "error"
                              }`}
                              placeholder="*******"
                            />

                            {errors.password && (
                              <FormError message={errors.password.message} />
                            )}
                          </div>
                          <PasswordStrenghtMeter password={watch('password') || ''}/>
                          
                        </div>
                        <div className="col-4" style={{display:"none"}}>
                          <div className="form-group mb-3">
                            <label htmlFor="confPass" className={`input-lable ${errors.confPass && "error"}`}>
                              Confirm Password
                            </label>
                            <input
                              type="password"
                              {...register("confPass")}
                              className={`input-label form-control ${
                                errors.confPass && "error"
                              }`}
                              placeholder="*******"
                            />
                            {errors.confPass && (
                              <FormError message={errors.confPass.message} />
                            )}
                          </div>
                        </div></React.Fragment>:''
                  }  */}
                  <div className="row">
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label className={`d-block ${errors.state && "error"}`}>
                          State
                        </label>
                        <Controller
                          control={control}
                          name="state"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={states}
                              isClearable={true}
                              onChange={(opt) => onStateChange(onChange, opt)}
                              value={states.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.state && (
                          <FormError message={errors.state.message} />
                        )}
                      </div>
                    </div>
                    
                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label className={`d-block ${errors.city && "error"}`}>
                          City
                        </label>
                        <Controller
                          control={control}
                          name="city"
                          //value={defaultConfig.status[0]["value"]}
                          //defaultValue={defaultConfig.status[0]["value"]}
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={cities}
                              isClearable={true}
                              onChange={(opt) => onCityChange(onChange, opt?.value)}
                              value={cities.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.city && (
                          <FormError message={errors.city.message} />
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          
                          className={`input-label ${errors.pincode && "error"}`}
                        >
                          Pincode
                        </label>
                        <Controller
                          control={control}
                          name="pincode"
                          //value={defaultConfig.status[0]["value"]}
                          //defaultValue={defaultConfig.status[0]["value"]}
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={pincodes}
                              isClearable={true}
                              onChange={(opt) => onPincodeChange(onChange, opt?.value)}
                              value={pincodes.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.pincode && (
                          <FormError message={errors.pincode.message} />
                        )}
                      </div>
                    </div>
                    
                    <div className="col-4">
                      <div className="row">
                      <div className="form-group mb-3 col-sm-8 pr-0">
                        <label className={`d-block ${errors.latLang && "error"}`}>
                          Location
                        </label>
                        <input
                          type="hidden"
                          className={`input-label form-control ${
                            errors.latLang && "error"
                          }`}
                          readOnly
                          placeholder="Lat&Long"
                          {...register("lat_long")}
                        />  
                        <input
                          type="text"
                          className={`input-label form-control ${
                            errors.latLang && "error"
                          }`}
                          readOnly
                          placeholder="Location"
                          {...register("location")}
                        />  
                      </div>
                      <div className="form-group mb-3 col-sm-4 pl-0">
                        <label className="d-block">&nbsp;</label>
                        <button onClick={openMap} type="button" className="btn-success btn-sl"><i className="fa fa-location-arrow "></i></button>
                      </div>
                      </div>
                    </div>
                    {
                      params.type === "retailers" ? 
                        <div className="col-4">
                          <div className="form-group mb-3">
                            <label
                              
                              className={`d-block ${errors.category && "error"}`}
                            >
                              Category
                            </label>
                            <Controller
                              control={control}
                              name="category"
                              //value={defaultConfig.status[0]["value"]}
                              //defaultValue={defaultConfig.status[0]["value"]}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={cateList}
                                  isClearable={true}
                                  onChange={(opt) => onChange(opt?.value)}
                                  value={cateList.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                            {errors.category && (
                              <FormError message={errors.category.message} />
                            )}
                          </div>
                        </div>:''
                    }
                    {/* <div className="col-4">
                      <div className="form-group mb-3">
                        <label className={`d-block ${errors.forRegion && "error"}`}>
                          Service Area
                        </label>
                        <Controller
                          control={control}
                          name="forRegion"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.regionFor}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={defaultConfig.regionFor.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.forRegion && (
                          <FormError message={errors.forRegion.message} />
                        )}
                      </div>
                    </div> */}


                    <div className="col-4">
                      <div className="form-group mb-3">
                        <label
                          className={`d-block ${errors.name && "error"}`}>
                          Status
                        </label>
                        <Controller
                          control={control}
                          name="status"
                          //value={defaultConfig.status[0]["value"]}
                          defaultValue={defaultConfig.status[0]["value"]}
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.status}
                              isClearable={true}
                              onChange={(opt) => onStatusChange(onChange, opt?.value) }
                              value={defaultConfig.status.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {(errors.status || errors?.replaceById) && (
                          <FormError message={errors?.status?.message || errors?.replaceById?.message} />
                        )}
                      </div>
                    </div>
                    {
                      ["retailers", "superStockists", 'distributors'].indexOf(params.type) >= 0? 
                      <div className="col-4">
                        <div className="form-group mb-3">
                          <label className={`d-block ${errors.parentUser && "error"}`}>
                            {parentField?.label}
                          </label>
                          <Controller
                            control={control}
                            name="parentUser"
                            render={({ field: { value, onChange } }) => (
                              <SelectBox
                                options={parentList}
                                isClearable={true}
                                onChange={(opt) => onChange(opt?.value)}
                                value={parentList?.find(
                                  (option) => option.value === value
                                )}
                              />
                            )}
                          />
                          {errors.parentUser && (
                            <FormError message={errors.parentUser.message} />
                          )}
                        </div>
                      </div>:''
                    }
                    <div className={"col-8"}>
                        <div className="form-group mb-3">
                          <label
                              
                              className={
                              errors?.address && "error"}>
                              Address
                          </label>
                          <textarea
                              rows="5"
                              defaultValue=""
                              {...register(`address`)}
                              placeholder="Address"
                              className={`form-control ${
                                errors?.address?.message && "error"
                              }`}
                          />
                          {errors?.address?.message && (
                              <FormError
                              message={
                                errors?.address?.message
                              }
                              />
                          )}
                        </div>
                    </div>    
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <ul>
                        <li className="text-dark"><b>*Image size should not be more than 200kb</b></li>
                        <li className="text-dark"><b>*Allow only .Jpeg and .Png image type </b></li>
                      </ul>
                    </div>
                    {
                      imagesType.map((item, index)=>{
                          return (
                            <div key={index} className="col-sm-2 pl-0 pr-0">
                              <div className="img-prev col-12 form-group">
                                  <label
                                      htmlFor="">
                                      {item.label}
                                  </label>
                                  <div className="ImgPreview">
                                    <img src={item.imagePath} alt="" />
                                  </div>
                                  <div className="file btn btn-lg btn-primary fileUpload col-sm-9">
                                      Upload
                                      <input 
                                        type="file"  
                                        {...register(item.name)} 
                                        accept="image/png, image/jpeg"
                                        onChange={(event)=> onDrop(event)}
                                      />
                                  </div>
                                  <br/>
                                  {errors[item.name] && (
                                    <FormError message={errors[item.name]?.['message']} />
                                  )}   
                              </div>
                            </div>
                          )
                      })
                    }
                  </div>
                  <hr/>
                  <div className="col-12 mb-3 text-right">
                    <button type="submit" className="btn btn-success btn-lg mx-2">
                      Save
                    </button>
                    <button type="button" onClick={onCancel} className="btn btn-danger btn-lg">
                      Cancel
                    </button>
                  </div>
            </form>
          </div>
          {isMapOpen?<GoogleMap setLocationData={setLocationData} data={ {latLng} } openMap={openMap} />:''}
        </div>
      </div>
      {loading === true || initialData.loading?<Loading/>:"" }
      {success || vErrors? 
        <MessageModel
          btnEvent={ ()=>{
            dispatch(resetApiStatus()) 
            if(success) 
            navigate(`/shopping-partners/${params.type}`);
          } }
          success={success?true:false}
          message={success || vErrors}
        />
      :""}

    { showStatusPopup ?
        <ModelBox data={ {
          size: "md", 
          show: true, 
          title: `Replace ${vendorType} `, 
          content: { ...popUpContent },
          onClose: () => {
            setShowStatusPopup(false);
          }
          
         
      } } /> : ''
      } 
      
    </div>
  );
}
